export class LoginLoggedout {
}
